import * as Yup from 'yup';

export const cancelRideValidationSchema = () =>
  Yup.object().shape({
    tripCancellation: Yup.object().shape({
      adminCancellationReason: Yup.string().required('Required Field'),
      requestedBy: Yup.string().required('Required Field'),
    }),
  });
